import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

document.addEventListener('DOMContentLoaded', () => {
    const swiperContainer = document.querySelector('.knowledge-posts-swiper');

    if (!swiperContainer) {
        return;
    }

    const staffSwiper = new Swiper(swiperContainer, {
        modules: [Navigation, Pagination],
        slidesPerView: 'auto',
        spaceBetween: 16,
        loop: false,
        navigation: {
            prevEl: swiperContainer.querySelector('.swiper-button-prev'),
            nextEl: swiperContainer.querySelector('.swiper-button-next'),
        },
        pagination: {
            el: swiperContainer.querySelector('.swiper-pagination'),
            clickable: true,
        },
    });
});